import classnames from 'clsx';

import { FlexRow } from 'ui-components/components/flex';

import style from './cost-review-line.module.css';

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {string} [props.className]
 * @returns {JSX.Element}
 */
export const CostReviewLine = ({ children, className }) => {
  return <FlexRow className={classnames(style['cost-review-line'], className)}>{children}</FlexRow>;
};
